import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from './analytics';
import Home from './pages/Home';
import AboutUsPage from './pages/AboutUsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import ContactUsPage from './pages/ContactUsPage';

// Component to track page views on route changes
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    // Initialize analytics after component mounts (non-blocking)
    // Use setTimeout to ensure it doesn't block initial render
    const timer = setTimeout(() => {
      initAnalytics();
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
